module.exports = __webpack_public_path__ + "static/media/Noibat_gaussian2.2bde5c7b.png";